<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import './index.scss';

    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .pagination-box {
        padding: 22px 0;
        text-align: right;
    }
</style>
